/**
 * Created by OBL on 14/01/2016.
 */
define('adminKitProtsController',[
    'module',
    'underscore',
    'app',
    'adminKitProtsView',
    'bootbox',
    'kitProtCreateEditLayoutView',
    'settings',
    'entities/kitprots'
], function(
    module,
    _,
    App,
    View,
    bootbox,
    CreateEditLayoutView
    ) {
    'use strict';

    var AdminKitProtListController = {
        showKitProtList: function(data) {
            var view = new View({data: data});
            this.view = view;
            view.listenTo(view, 'onGridLoaded', _.bind(this.onGridLoaded, this));
            view.listenTo(view, 'kitprot:delete', _.bind(this.onDelete, this));
            App.regions.getRegion('main').currentView.getRegion('content').show(view);
        },

        showKitProtAdd: function() {
            this.createEditView = new CreateEditLayoutView({
                kitProtModel: App.request('kitprot:model'),
                newItem: true
            });
            this.createEditView.show({
                title: _.i18n('kitprot.new')
            });
        },

        onGridLoaded: function() {
            var data = {
                url: App.request('kitprot:get-collection-url'),
                rowCountUrl: App.request('kitprot:get-count-url')
            };

            this.view.displayGrid(data);
        },

        onDelete: function(secId){
            bootbox.confirm(_.i18n('kitprot.confirmDelete'), _.bind(function(result) {
                if(result){
                    App.request('kitprot:delete', secId)
                        .done(_.bind(function(){
                            this.view.updatePagination('reloadGrid');
                        }, this));
                }
            }, this));
        }
    };

    module.exports = AdminKitProtListController;
});
